module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-5.4352747b.webp";